module.exports = __webpack_public_path__ + "static/data-engineering-pic-icon-2791ff3477aa3f4cb84cabdfaa3d1813.png";